import { render, staticRenderFns } from "./ManageAccess.vue?vue&type=template&id=39c8772b&scoped=true"
import script from "./ManageAccess.vue?vue&type=script&lang=js"
export * from "./ManageAccess.vue?vue&type=script&lang=js"
import style0 from "./ManageAccess.vue?vue&type=style&index=0&id=39c8772b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c8772b",
  null
  
)

export default component.exports